var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBudgetAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.555664,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#3CC7DF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5557 22C11.3457 22 9.55566 23.79 9.55566 26C9.55566 28.21 11.3457 30 13.5557 30C15.7657 30 17.5557 28.21 17.5557 26C17.5557 23.79 15.7657 22 13.5557 22ZM14.5557 25.68C14.5557 26.29 14.2257 26.87 13.7057 27.18L12.9457 27.64C12.8257 27.72 12.6857 27.75 12.5557 27.75C12.3057 27.75 12.0557 27.62 11.9157 27.39C11.7057 27.04 11.8157 26.57 12.1757 26.36L12.9357 25.9C13.0057 25.86 13.0557 25.77 13.0557 25.69V24.76C13.0557 24.34 13.3957 24 13.8057 24C14.2157 24 14.5557 24.34 14.5557 24.75V25.68Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5557 12H15.5557C12.5557 12 10.5557 13.5 10.5557 17V20.56C10.5557 20.93 10.9357 21.16 11.2657 21.01C12.2457 20.56 13.3757 20.39 14.5657 20.6C17.1957 21.07 19.1257 23.51 19.0557 26.18C19.0457 26.6 18.9857 27.01 18.8757 27.41C18.7957 27.72 19.0457 28.01 19.3657 28.01H25.5557C28.5557 28.01 30.5557 26.51 30.5557 23.01V17C30.5557 13.5 28.5557 12 25.5557 12ZM20.5557 22.5C19.1757 22.5 18.0557 21.38 18.0557 20C18.0557 18.62 19.1757 17.5 20.5557 17.5C21.9357 17.5 23.0557 18.62 23.0557 20C23.0557 21.38 21.9357 22.5 20.5557 22.5ZM27.8057 22C27.8057 22.41 27.4657 22.75 27.0557 22.75C26.6457 22.75 26.3057 22.41 26.3057 22V18C26.3057 17.59 26.6457 17.25 27.0557 17.25C27.4657 17.25 27.8057 17.59 27.8057 18V22Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBudgetAll);
export default __webpack_public_path__ + "static/media/budget_all.8f8f20ab59316196afa6abe9cd2d702f.svg";
export { ForwardRef as ReactComponent };